import { React } from 'react';
import { Link } from 'react-router-dom'
export function Adsense() {
    return <>
<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7896237768143480"
     crossorigin="anonymous"></script>
    </>
}

